module.exports = __webpack_public_path__ + "static/media/logo_maisapoio.57e4c8fe.png";